<div id="map" leaflet [leafletOptions]="mapOptions" (leafletMapReady)="onMapReady($event)" style="height:500px">
    <div *ngIf="marker" [leafletLayer]="marker"></div>
    <div *ngFor="let layer of markers" [leafletLayer]="layer"></div>
</div>